var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "OvwFull",

    getDefaultProps () {
        return {"width":"22px","height":"22px","viewBox":"0 0 22 22","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>Icon/ovw-full</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fillRule="evenodd">
    <g id="Icon/ovw-full">
      <rect id="Rectangle-5" x="1" y="1" width="20" height="1"/>
      <rect id="Rectangle-5-Copy-6" x="1" y="6" width="20" height="1"/>
      <rect id="Rectangle-5-Copy" x="1" y="1" width="1" height="5"/>
      <rect id="Rectangle-5-Copy-4" x="5" y="1" width="1" height="5"/>
      <rect id="Rectangle-5-Copy-4" x="9" y="1" width="1" height="5"/>
      <rect id="Rectangle-5-Copy-5" x="13" y="1" width="1" height="5"/>
      <rect id="Rectangle-5-Copy-7" x="17" y="1" width="1" height="5"/>
      <rect id="Rectangle-5-Copy-18" x="1" y="15" width="20" height="1"/>
      <rect id="Rectangle-5-Copy-16" x="1" y="20" width="20" height="1"/>
      <rect id="Rectangle-5-Copy-15" x="1" y="15" width="1" height="5"/>
      <rect id="Rectangle-5-Copy-14" x="5" y="15" width="1" height="5"/>
      <rect id="Rectangle-5-Copy-13" x="9" y="15" width="1" height="5"/>
      <rect id="Rectangle-5-Copy-12" x="13" y="15" width="1" height="5"/>
      <rect id="Rectangle-5-Copy-11" x="17" y="15" width="1" height="5"/>
      <rect id="Rectangle-5-Copy-3" x="1" y="8" width="13" height="1"/>
      <rect id="Rectangle-5-Copy-10" x="1" y="13" width="13" height="1"/>
      <rect id="Rectangle-5-Copy-2" x="1" y="8" width="1" height="5"/>
      <rect id="Rectangle-5-Copy-9" x="5" y="8" width="1" height="5"/>
      <rect id="Rectangle-5-Copy-8" x="9" y="8" width="1" height="5"/>
      <rect id="Rectangle-5-Copy-17" x="13" y="8" width="1" height="5"/>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/ui/images/ovw-full.svg